// oxlint-disable react/jsx-pascal-case
import { type Component, type ComponentProps, Show } from "solid-js";
import { cn } from "@listto/shared";

interface EmptyStateProps {
  icon: Component<ComponentProps<"svg">>;
  title: string;
  description?: string;
  class?: string;
}

export const EmptyState: Component<EmptyStateProps> = (props) => (
  <div class={cn("flex flex-1 flex-col items-center justify-center p-8 text-center", props.class)}>
    <div class="animate-scale-in">
      <div class="mb-6 rounded-full bg-primary/5 p-6 ring-1 ring-primary/10 animate-float">
        <props.icon class="h-12 w-12 text-primary/60" />
      </div>
    </div>
    <h3 class="text-lg font-semibold tracking-tight">{props.title}</h3>
    <Show when={props.description}>
      <p class="mt-2 text-sm text-muted-foreground max-w-xs mx-auto">{props.description}</p>
    </Show>
  </div>
);
